import * as React from "react";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
} from "@mui/material";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },
  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ campaigns, component, categorize }) {
  const navigate = useNavigate();

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleRedirection(campaign, mode) {
    if (component === "request") {
      navigate(
        pages.campaignRequestDetails.route +
          campaign.sender_campaignId +
          "?brandID=" +
          campaign.sender_brandId +
          "&mode=" +
          mode
      );
    }

    if (component === "superadmin") {
      navigate(
        pages.superAdminCampaignDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode,
        { state: { categorize: categorize } }
      );
    }

    if (component === "accepted") {
      navigate(
        pages.campaignAcceptedDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode
      );
    }

    if (component === "") {
      navigate(
        pages.campaignDetails.route + campaign.campaign_id + "?mode=" + mode
      );
    }
  }

  return (
    <TableContainer
      sx={{ maxHeight: "90%", borderRadius: "10px" }}
      component={Paper}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            <StyledTableCell>Campaign Name</StyledTableCell>
            <StyledTableCell>Campaign Period</StyledTableCell>
            <StyledTableCell>Conversion</StyledTableCell>
            {/* <StyledTableCell>User Count</StyledTableCell> */}
            <StyledTableCell>Approval Status</StyledTableCell>
            <StyledTableCell>Campaign Status</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {campaigns.map((campaign) => (
            <StyledTableRow>
              <Fragment>
                <StyledTableCell component="th" scope="row">
                  {campaign.campaign_name}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {!!campaign.start_duration
                    ? convertDate(campaign.start_duration) +
                      " - " +
                      convertDate(campaign.end_duration)
                    : "N.A."}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {campaign.conversion_type || "N.A."}
                </StyledTableCell>

                {/* <StyledTableCell component="th" scope="row">
                  {campaign.user_Count || "N.A"}
                </StyledTableCell> */}

                <StyledTableCell>
                  <StatusChip campaign={campaign} label="approval" />
                </StyledTableCell>

                <StyledTableCell>
                  <StatusChip campaign={campaign} label="campaign_status" />
                </StyledTableCell>

                <StyledTableCell>
                  <Tooltip title="View Campaign">
                    <Icon>
                      <CgEye
                        onClick={() => handleRedirection(campaign, "view")}
                        style={{ height: "20px", width: "20px" }}
                      />
                    </Icon>
                  </Tooltip>
                </StyledTableCell>
              </Fragment>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function StatusChip({ campaign, label }) {
    let color;
    let status;
    if (label === "approval") {
      status = campaign.status;
    }

    if (label === "campaign_status") {
      status = campaign.campaign_status;
    }

    if (status === "REQUESTED" || status === "CREATED") {
      color = colors.yellow;
    }

    if (
      status === "ACCEPTED" ||
      status === "OFFER_ACCEPTED" ||
      status === "ACTIVE" ||
      status === "PARTIAL_ACCEPTED"
    ) {
      color = colors.green;
    }

    if (status === "INITIATED") {
      color = colors.initiated;
    }

    if (
      status === "REJECTED" ||
      status === "FAILED" ||
      status === "MISSED" ||
      status === "PARTIAL_REJECTED" ||
      status === "OFFER_REJECTED" ||
      status === "INTERRUPTED"
    ) {
      color = colors.error;
    }

    if (status === "Expired") {
      color = "#bdbdbd";
    }

    if (status === "READY") {
      color = colors.success;
    }

    if (status === "COMPLETED") {
      color = "#2f8632";
    }
    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          fontSize: "13px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={status?.replace(/_/g, " ").toUpperCase()}
      />
    );
  }
}
